"use strict";function extendModal$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.extendModal$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="device.notification.extendModal";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.5.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.5.0"},_a)),exports.extendModal$=extendModal$,exports.default=extendModal$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/device/notification/extendModal.js
// module id = 1070
// module chunks = 106